import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { apiRequestCall } from 'app/services/api';
import { cancelationSubscribe } from 'app/services/api/utils';
import { ApiResource } from 'app/services/api/enums';
import { entityStoreStatus } from 'app/utils/store/entity-store-status';
import { ExchangeRatesState } from './interfaces';
import { entityAdapter } from './adapter';
import { ExchangeRateDto } from 'app/interfaces/dto';
import { ExchangeRatesStoreStatus } from './enums';

export const getExchangeRates = createAsyncThunk(
  `${EntityStoreName.ExchangeRates}/getExchangeRates`,
  (properties, { signal }): Promise<ExchangeRateDto[]> => {
    const cancelToken = cancelationSubscribe(signal);

    return apiRequestCall<ExchangeRateDto[]>({
      params: {
        method: 'GET',
        resource: ApiResource.Payments,
        urlPrefix: 'exchange-rates',
        cancelToken,
      },
    });
  }
);

export const updateExchangeRatesReducer = (
  state: ExchangeRatesState,
  action: PayloadAction<ExchangeRateDto[]>
): void => {
  entityAdapter.setAll(state, action.payload);
};

export const registerReducers = (builder: ActionReducerMapBuilder<ExchangeRatesState>): void => {
  builder
    .addCase(getExchangeRates.pending, (state, action) => {
      entityStoreStatus.addRequestId(
        state,
        ExchangeRatesStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(getExchangeRates.fulfilled, (state, action) => {
      entityAdapter.setAll(state, action.payload);
      entityStoreStatus.removeRequestId(
        state,
        ExchangeRatesStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(getExchangeRates.rejected, (state, action) => {
      entityStoreStatus.removeRequestId(
        state,
        ExchangeRatesStoreStatus.Loading,
        action.meta.requestId
      );
    });
};
